<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Bulk Workflow Update
</h1>
<form class="form" mat-dialog-content (ngSubmit)="onSave()" *ngIf="NgFormGroup" matForm [formGroup]="NgFormGroup">
    <br />
    <div class="guidance">Use this dialog to transition the selected forms from one workflow stage to another.</div>
    <br />
    <div *ngIf="!TransitionCompleted">
        <div *ngIf="!this.UserWorkflowTransitions || this.UserWorkflowTransitions.length == 0">
            No workflow transitions available for the selected forms.
        </div>
        <mat-form-field *ngIf="this.UserWorkflowTransitions?.length > 0" appearance="outline" [floatLabel]="'always'" class="select">
            <mat-label>Workflow Transition</mat-label>
            <mat-select formControlName="transitionSelect" [(ngModel)]="SelectedWorkflowTransitionId">
                <ng-container>
                    <mat-option [value]="-1">-- Choose a Workflow Transition--</mat-option>
                    <mat-option *ngFor="let t of this.UserWorkflowTransitions" [value]="t.workflowTransitionId">
                        {{t.workflowTransitionName}}
                        ({{t.startWorkflowState}} to {{t.endWorkflowState}})
                    </mat-option>
                </ng-container>
            </mat-select>
        </mat-form-field>
    </div>

    <div *ngIf="TransitionCompleted">
        <div *ngIf="TransitionedFormInstances && TransitionedFormInstances.length == 0">
            No form instances found for selected transition.
        </div>
        <div *ngIf="TransitionedFormInstances && TransitionedFormInstances.length > 0">
            <span *ngIf="TransitionedFormInstances.length == 1">Transition applied to form instance:</span>
            <span *ngIf="TransitionedFormInstances.length > 1">Transition applied to {{TransitionedFormInstances.length}} form instances:</span>
            <br />
            <div class="fi-list">
                <ul>
                    <ng-container *ngFor="let tfi of TransitionedFormInstances">
                        <li>{{tfi.name}}</li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>

</form>
<div mat-dialog-actions>
    <button *ngIf="!TransitionCompleted" mat-flat-button color="primary" class="theme-primary-btn" (click)="onSave()" [disabled]="OKDisabled">OK</button>
    <button *ngIf="!TransitionCompleted" mat-flat-button color="basic" class="form-button-secondary" [mat-dialog-close]="null" style="margin-left: 10px;">Cancel</button>
    <button *ngIf="TransitionCompleted" mat-flat-button color="basic" class="form-button-secondary" [mat-dialog-close]="null" style="margin-left: 10px;">Close</button>
</div>
